

const sanitizePhone = (raw) => {
  return (raw || "").replace(/[^+\d]/g, "");
};

export const actionHandler = {
  call: (value, isMobile) => {
    if (!isMobile) return undefined;
    const sanitized = sanitizePhone(value);
    return sanitized ? `tel:${sanitized}` : undefined;
  },

  mail: (value) => {
    return value ? `mailto:${value}` : undefined;
  },
};

export const getActionHref = ({ actionType, value, isMobile }) => {
  return actionHandler[actionType]?.(value, isMobile);
};


